import { FC } from 'react';
import { RULES_ID } from '@pro/420CheckIn/constant';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n';
import { HtmlRender } from '@base/snippets/HtmlRender';

export const Rules: FC = () => {
    const { t } = useTrans();
    return (
        <div className={styles.rules} id={RULES_ID}>
            <HtmlRender
                className={'g-wrapper'}
                html={t('web_checkin_rules')}
            />
        </div>
    )
};
